import { CardList, CardListRow } from '@/components/ui/Card'
import { AvatarCell } from '@/components/shared'
import type { ActivityEntry } from '@/models'

export function ActivityList({ entries }: { entries: readonly ActivityEntry[] }) {
  return (
    <CardList>
      {entries.map((entry) => (
        <CardListRow key={entry.id}>
          <AvatarCell name={entry.who} />
          <span className="min-w-0 flex-1 text-sm">
            <span className="text-fg font-semibold">{entry.who}</span>{' '}
            <span className="text-fg-muted">{entry.what}</span>
          </span>
          <span className="text-fg-subtle shrink-0 text-xs tabular-nums">{entry.ago}</span>
        </CardListRow>
      ))}
    </CardList>
  )
}
